import type { CreateAccessTokenRequest } from "@sakura-tech-lab/dashboard-api";

import { tokensApi } from "@/services/dashboard-api.client";

export async function createAccessToken(
  request: CreateAccessTokenRequest = {},
): Promise<string> {
  const response = await tokensApi.createAccessToken({
    createAccessTokenRequest: request,
  });
  return response.data.token;
}
